// extracted by mini-css-extract-plugin
export default {"content":"TotalWorkBox_content__ihXXM","content__left":"TotalWorkBox_content__left__KT5IA","content__right":"TotalWorkBox_content__right__a+RzM"};